import { Routes } from '@angular/router';
import { PageContainerHeaderComponent } from './core/components/page-container-header/page-container-header.component';
import { authenticationGuard } from './core/guards/authentication.guard';
import { notAuthenticatedGuard } from './core/guards/not-authenticated.guard';

export const routes: Routes = [
    {
        path: '',
        component: PageContainerHeaderComponent,
        canActivate: [authenticationGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'projects'
            },
            {
                path: 'projects',
                loadChildren: () => import('./projects/projects.routes').then(routes => routes.PROJECTS_ROUTES)
            },
            {
                path: 'all-projects',
                loadChildren: () => import('./projects/projects.routes').then(routes => routes.PROJECTS_ROUTES)
            },
            {
                path: 'project/:idProject',
                loadComponent: () => import('./project-wizard/pages/project-wizard/project-wizard.component').then(component => component.ProjectWizardComponent),
                loadChildren: () => import('./project-wizard/project-wizard.routes').then(routes => routes.PROJECT_WIZARD_ROUTES),
            }
        ]
    },
    {
        path: "authentication",
        canActivate: [notAuthenticatedGuard],
        loadChildren: () => import('./authentication/authentication.routes').then(routes => routes.AUTHENTICATION_ROUTES)
    },
    {
        path: '**',
        redirectTo: "/authentication/sign-in"
    }
];
